import { without } from 'ramda';
import PropTypes from 'prop-types';
import SaveCancelButton from '../save-cancel-button/SaveCancelButton.jsx';

import s from './PoiSheet.module.scss';

const PoiSave = ({ onClose, errorMessage, changedFields, isSaving, poi, onSave, isVisible, isMovePoiSaveMode, isTranslatedVenue, hasInvalidUrl, hasInvalidPhoneExtension }) =>
    isVisible || isMovePoiSaveMode ? (
        <div className={s.saveCancelRow}>
            <SaveCancelButton
                changeCount={without(['imagesHasFailedImages', 'logoHasFailedImages'], changedFields).length + (isMovePoiSaveMode ? 1 : 0)}
                onSave={onSave}
                onCancel={onClose}
                errorMessage={errorMessage}
                saveLabel="SAVE POI"
                saveDisabled={
                    isSaving ||
                    poi.imagesHasFailedImages === true ||
                    poi.logoHasFailedImages === true ||
                    hasInvalidUrl ||
                    hasInvalidPhoneExtension ||
                    isTranslatedVenue
                }
            />
        </div>
    ) : null;

PoiSave.propTypes = {
    changedFields: PropTypes.arrayOf(PropTypes.string),
    errorMessage: PropTypes.string,
    isSaving: PropTypes.bool,
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
    onSave: PropTypes.func,
    poi: PropTypes.object,
    isMovePoiSaveMode: PropTypes.bool,
    isTranslatedVenue: PropTypes.bool,
    hasInvalidUrl: PropTypes.bool,
    hasInvalidPhoneExtension: PropTypes.bool,
};

PoiSave.defaultProps = {
    changedFields: [],
    errorMessage: '',
    isSaving: false,
    isVisible: false,
    onClose: () => {},
    onSave: () => {},
    poi: {},
    isMovePoiSaveMode: false,
    isTranslatedVenue: false,
    hasInvalidUrl: false,
    hasInvalidPhoneExtension: false,
};

export default PoiSave;
